import React, { useState } from 'react'
import { Icon } from "@iconify/react/dist/iconify.js";

const DashboardFilter = ({ filter, onFilterChange, customRange, setCustomRange, onCustomApply, loading }) => {
  const [showCustom, setShowCustom] = useState(false);

  const filterOptions = [
    { value: 'all', label: 'All time' },
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'this_week', label: 'This week' },
    { value: 'this_month', label: 'This month' },
    { value: 'custom', label: 'Custom range' },
  ];

  const handleSelectChange = (e) => {
    const value = e.target.value;
    onFilterChange(value);
    setShowCustom(value === 'custom');
  };

  const getLabel = () => {
    switch (filter) {
      case 'all': return 'Showing all-time stats';
      case 'today': return "Showing today's stats";
      case 'yesterday': return "Showing yesterday's stats";
      case 'this_week': return "Showing this week's stats (Mon - Sun)";
      case 'this_month': return "Showing this month's stats";
      case 'custom':
        return customRange.startDate && customRange.endDate
          ? `Showing ${customRange.startDate} to ${customRange.endDate}`
          : 'Select a custom range';
      default: return '';
    }
  };

  return (
    <div className="card radius-12 border bg-base p-3 mb-0">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <select
            className="form-select form-select-md w-auto radius-8"
            value={filter}
            onChange={handleSelectChange}
            style={{ minWidth: '160px' }}
          >
            {filterOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          {showCustom && (
            <div className="d-flex align-items-center gap-2">
              <input
                type="date"
                className="form-control form-control-sm radius-8"
                value={customRange.startDate}
                max={customRange.endDate || undefined}
                onChange={(e) => setCustomRange((prev) => ({ ...prev, startDate: e.target.value }))}
              />
              <span className="text-secondary-light text-sm">to</span>
              <input
                type="date"
                className="form-control form-control-sm radius-8"
                value={customRange.endDate}
                min={customRange.startDate || undefined}
                onChange={(e) => setCustomRange((prev) => ({ ...prev, endDate: e.target.value }))}
              />
              <button
                className="btn btn-primary-600 btn-sm radius-8"
                onClick={onCustomApply}
                disabled={!customRange.startDate || !customRange.endDate || loading}
              >
                {loading ? (
                  <Icon icon="eos-icons:loading" className="icon" />
                ) : (
                  'Apply'
                )}
              </button>
            </div>
          )}
        </div>

        <div className="d-flex align-items-center gap-1">
          {loading && filter !== 'custom' && (
            <Icon icon="eos-icons:loading" className="icon text-primary-600" />
          )}
          <span className="text-secondary-light text-sm">{getLabel()}</span>
        </div>
      </div>
    </div>
  );
};

export default DashboardFilter;